<template>
  <div class="community-stats">
    Community
    <ul class="stats-list">
      <li v-if="completeCount > -1">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined -complete">check_circle</i>
        </span>
        <span class="detail-value" aria-label="Completes">{{ numberFormat(completeCount) }}</span>
      </li>
      <li v-if="favoriteCount > -1">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined fill -content-match">favorite</i>
        </span>
        <span class="detail-value" aria-label="Favorites">{{ numberFormat(favoriteCount) }}</span>
      </li>
      <li v-if="likeCount > -1">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined -like">thumb_up</i>
        </span>
        <span class="detail-value" aria-label="Likes">{{ numberFormat(likeCount) }}</span>
      </li>
      <li v-if="commentCount > -1">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined -comments">comment</i>
        </span>
        <span class="detail-value" aria-label="Comments">{{ numberFormat(commentCount) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { numberFormat } from '@/utils/helpers'

/**
 * Generic community stats that shows in expander content.
 */
export default {
  name: 'StatsCommunity',
  components: {},
  props: {
    // -1 = hidden
    commentCount: {
      type: Number,
      default: -1,
    },
    favoriteCount: {
      type: Number,
      default: -1,
    },
    likeCount: {
      type: Number,
      default: -1,
    },
    completeCount: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    // proxy method
    numberFormat(val) {
      return numberFormat(val)
    },
  },
}
</script>
